import { Typography, FormControlLabel, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ChangeEvent } from "react";

type PaymentCheckboxProps = {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
};

function PaymentCheckbox({ checked, onCheckedChange }: PaymentCheckboxProps) {
  const { t } = useTranslation();

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    onCheckedChange(event.target.checked);
  };

  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={handleCheckboxChange} />}
      label={
        <Typography variant="body1" sx={{ fontWeight: "medium" }}>
          {t(
            "Έχω λάβει γνώση ότι η καταβολή του προστίμου συνεπάγεται την αυτοδίκαιη παραίτησή μου από κάθε δικαίωμα προσβολής ή αμφισβήτησης της πράξης επιβολής.",
          )}
        </Typography>
      }
    />
  );
}

export default PaymentCheckbox;
